import { NavigateOptions, To, useNavigate } from 'react-router-dom';

export const useAppNavigation = () => {
  const _navigate = useNavigate();

  const navigate = (to: To, options?: NavigateOptions, searchParams?: Record<string, string>): void => {
    const params = new URLSearchParams(window.location.search);

    // add or update the new search parameters
    if (searchParams) {
      Object.keys(searchParams).forEach((key) => {
        params.set(key, searchParams[key]);
      });
    }

    const toWithParams = `${to}?${params.toString()}`;

    _navigate(toWithParams, options);
  };

  return { navigate };
};
